// bid-brief-pdf is reserved; a value added later costs a migration.
export const ANALYSIS_EXPORT_KIND_VALUES = {
  bidItemsCsv: 'bid-items-csv',
  tableSnapCsv: 'table-snap-csv',
  projectLogCsv: 'project-log-csv',
  bidBriefPdf: 'bid-brief-pdf',
} as const;

export type AnalysisExportKind =
  (typeof ANALYSIS_EXPORT_KIND_VALUES)[keyof typeof ANALYSIS_EXPORT_KIND_VALUES];
